import Cookies from 'js-cookie'

const state = {
  entrust: null,
  evaluateEntrust: null
}

const mutations = {
  SET_ENTRUST: (state, entrust) => {
    Cookies.set('entrust', entrust)
    state.sidebar.entrust = entrust
  },
  SET_EVALUATE_ENTRUST: (state, evaluateEntrust) => {
    Cookies.set('evaluateEntrust', evaluateEntrust)
    state.sidebar.evaluateEntrust = evaluateEntrust
  }
}

const actions = {
  setEntrust ({ commit }, entrust) {
    commit('SET_ENTRUST', entrust)
  },
  setEvaluateEntrust ({ commit }, evaluateEntrust) {
    commit('SET_ENTRUST', evaluateEntrust)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/transfer.js